


















































import { MessageDialog } from "../../../utils/MessageDialog";
import { Teacher } from "../../../../src_server/entity/generated/Teacher";
import { Vue, Component, Prop } from "vue-property-decorator";
import { getTeacherSuffixInSession } from "../../../utils/building_trans";

@Component({ components: {} })
export default class LessonPanelTeacherComments extends Vue {
  @Prop()
  teacherNickname!: string;
  @Prop()
  teacherComment!: string;
  @Prop()
  teacher_thumbnail!: string;

  @Prop({ default: "" })
  teacher!: Teacher;

  openZoom() {
    if (this.teacher.zoom_url) {
      window.open(this.teacher.zoom_url, "_blank");
    } else {
      MessageDialog.alert(
        `${
          this.teacherNickname
        }${getTeacherSuffixInSession()}のワンクリックZoomURLが設定されていません。`
      );
    }
  }
}
